
 const RolesTypes = {
    Admin : "Admin",    
    Dev_Team : "Dev_Team",
    Support_Team : "Support_Team",
    Updater_Apk : "Updater_Apk",
    Reseller_Support : "Reseller_Support",
    Support_Manager : "Support_Manager",
}
export default RolesTypes;


// WEBPACK FOOTER //
// ./src/utils/roles.js